var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageCloudCorner = function SvgMessageCloudCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.002-77.07c0-17.083 13.245-30.93 29.583-30.93h537.832C601.755-108 615-94.152 615-77.07v68.14C615 8.153 601.755 22 585.417 22H47.585c-83.202 0-29.583-5.632-29.583-22.714z"
  })));
};
export default SvgMessageCloudCorner;